var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnDestroy, OnInit } from '@angular/core';
import { Rule } from "app/models/group_ref.model";
import { GroupRefService } from "./group_ref.service";
import { ConfirmComponent } from "app/views/modal/confirm.component";
import { PromptComponent } from "app/views/modal/prompt.component";
import { AlertComponent } from "app/views/modal/alert.component";
import { TranslateService } from "app/translate/translate.service";
import { ModalService } from "app/views/modal/base_modal.component";
function checkName(name) {
    return /^[a-z-A-Z0-9]{2,}$/.test(name);
}
var GroupRefComponent = /** @class */ (function () {
    function GroupRefComponent(groupRefService, modalService, _translate) {
        var _this = this;
        this.groupRefService = groupRefService;
        this.modalService = modalService;
        this._translate = _translate;
        this.rulesBusy = [];
        this.previewRules = [];
        this.checkInterval = null;
        this.groups = [];
        this.sources = [];
        this.rebuilding = { status: false, procent: 0, dateStart: '' };
        this.groupsSortOptions = {
            onUpdate: function (event) {
                _this.groups.forEach(function (group, i) {
                    group.priority = i;
                });
                _this.groupRefService.sortGroups(_this.groups).subscribe(function (data) {
                    console.log(data);
                });
            }
        };
        this.sourcesSortOptions = {
            onUpdate: function (event) {
                _this.sources.forEach(function (source, i) {
                    source.priority = i;
                });
                _this.groupRefService.sortSources(_this.sources).subscribe(function (data) {
                    console.log(data);
                });
            }
        };
    }
    GroupRefComponent.prototype.handleError = function (error) {
        if (error == '500 - Internal Server Error referer rebuilding is active!') {
            this.modalService.open(AlertComponent, {
                title: 'Внимание!',
                message: 'В данный момент запущено перестроение рефереров! Вы не можете вносить изменения.'
            });
            this.rebuilding = {
                status: true,
                procent: 1,
                dateStart: ''
            };
        }
    };
    GroupRefComponent.prototype.getGroups = function () {
        var _this = this;
        this.groupsBusy = this.groupRefService.getGroups()
            .subscribe(function (groups) { return _this.groups = groups; }, this.handleError);
    };
    GroupRefComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.clearInterval();
        this.checkInterval = setInterval(function () {
            _this.groupRefService.getStatus()
                .subscribe(function (data) {
                if (data.isActive == 0) {
                    _this.rebuilding = {
                        status: false,
                        procent: 0,
                        dateStart: ''
                    };
                    return;
                }
                _this.rebuilding = {
                    status: data.isActive,
                    procent: data.procent,
                    dateStart: data.dateStart
                };
            });
        }, 30 * 1000);
        if (this.rebuilding.status === false) {
            this.getGroups();
        }
    };
    GroupRefComponent.prototype.clearInterval = function () {
        if (this.checkInterval) {
            clearInterval(this.checkInterval);
        }
    };
    GroupRefComponent.prototype.ngOnDestroy = function () {
        this.clearInterval();
    };
    GroupRefComponent.prototype.editGroup = function (id) {
        // Нужно добавить проверку на бэкенде, что группа с таким названием уже есть
        var me = this, group = this.groups.find(function (g) { return g.id === id; });
        var r = this.modalService.open(PromptComponent, {
            title: this._translate.instant('adminstat.users.group_ref_new.group editing'),
            question: this._translate.instant('adminstat.users.group_ref_new.enter new group name'),
            message: group.name
        });
        // Что тут блять твориться? Добавил заглушку для отмены
        r.result.then(function (newGropName) {
            if (newGropName === 'cancel') {
                return;
            }
            if (!checkName(newGropName)) {
                me.modalService.open(AlertComponent, {
                    title: 'Имя должно состоять из латинских букв и цифр',
                    message: 'Например "NewCampaign"'
                });
                return;
            }
            newGropName = newGropName.replace(/"/g, '');
            me.groupRefService.renameGroup(id, newGropName).subscribe(function (data) {
                console.log(data);
            });
            me.groups.forEach(function (group) {
                if (group.id == id) {
                    group.name = newGropName;
                }
            });
        });
    };
    GroupRefComponent.prototype.deleteGroup = function (id) {
        var me = this;
        var r = this.modalService.open(ConfirmComponent, {
            title: this._translate.instant('adminstat.users.group_ref_new.group deleting'),
            message: this._translate.instant('adminstat.users.group_ref_new.want delete group')
        });
        r.result.then(function (isConfirmed) {
            if (isConfirmed === true) {
                me.groupRefService.deleteGroup(id).subscribe(function (data) {
                    console.log(data);
                });
                me.groups = me.groups.filter(function (group) {
                    return group.id != id;
                });
            }
        });
    };
    GroupRefComponent.prototype.deleteSource = function (id, index) {
        if (id == 0) {
            this.sources.splice(index, 1);
        }
        else {
            var me_1 = this;
            var r = this.modalService.open(ConfirmComponent, {
                title: this._translate.instant('adminstat.users.group_ref_new.source deleting'),
                message: this._translate.instant('adminstat.users.group_ref_new.want delete source')
            });
            r.result.then(function (isConfirmed) {
                if (isConfirmed === true) {
                    me_1.groupRefService.deleteSource(id).subscribe(function (data) {
                        console.log(data);
                    });
                    me_1.sources = me_1.sources.filter(function (source) {
                        return source.id != id;
                    });
                }
            });
        }
    };
    GroupRefComponent.prototype.loadSource = function (index) {
        var _this = this;
        this.previewRules = [];
        this.rulesBusy[index] = this.groupRefService.getRules(this.sources[index].groupId, this.sources[index].id).subscribe(function (rules) {
            _this.sources[index].rules = rules;
            _this.previewRules = rules;
        });
    };
    GroupRefComponent.prototype.editSource = function (index) {
        this.sources[index].isSourceEdit = !this.sources[index].isSourceEdit;
        this.loadSource(index);
    };
    GroupRefComponent.prototype.addGroup = function () {
        // Нужно добавить проверку на бэкенде, что группа с таким названием уже есть
        var me = this;
        var r = this.modalService.open(PromptComponent, {
            title: this._translate.instant('adminstat.users.group_ref_new.group adding'),
            question: this._translate.instant('adminstat.users.group_ref_new.enter add group name'),
        });
        r.result.then(function (res) {
            // if (res && res.length > 2) {
            if (!checkName(res)) {
                me.modalService.open(AlertComponent, {
                    title: 'Имя должно состоять из латинских букв и цифр',
                    message: 'Например "NewCampaign"'
                });
                return;
            }
            res = res.replace(/"/g, '');
            me.groupsBusy = me.groupRefService.addGroup(res).subscribe(function (data) {
                console.log(data);
                me.groups.push({
                    id: data[1].insertId,
                    name: res,
                    priority: 0
                });
            });
        });
    };
    GroupRefComponent.prototype.addSource = function () {
        var rule = new Rule();
        rule.filter = 'utm_source';
        rule.state = 'equal';
        rule.text = this.currentGroup.name + " source";
        this.sources.push({
            id: 0,
            name: this.currentGroup.name + " source",
            priority: 0,
            groupId: this.currentGroup.id,
            isSourceEdit: true,
            rules: [rule]
        });
    };
    GroupRefComponent.prototype.saveSource = function (id, sourceIndex) {
        if (this.sources[sourceIndex].name == '') {
            this.modalService.open(AlertComponent, {
                title: this._translate.instant('adminstat.users.group_ref_new.save source'),
                message: this._translate.instant('adminstat.users.group_ref_new.enter title first')
            });
            return true;
        }
        var me = this;
        var r = this.modalService.open(ConfirmComponent, {
            title: this._translate.instant('adminstat.users.group_ref_new.save source'),
            message: this._translate.instant('adminstat.users.group_ref_new.want save rule')
        });
        r.result.then(function (isConfirmed) {
            if (isConfirmed === true) {
                // Поиск пустых правил
                var emptyRules_1 = 0;
                me.sources[sourceIndex].rules.forEach(function (rule) {
                    if (rule.filter == '' && rule.state == '' && rule.text == '') {
                        // if ( ! (rule.filter && rule.state && rule.text)) {
                        emptyRules_1++;
                    }
                });
                console.log('emptyRules', emptyRules_1);
                if (emptyRules_1 > 0) {
                    me.modalService.open(AlertComponent, {
                        title: me._translate.instant('adminstat.users.group_ref_new.save source'),
                        message: me._translate.instant('adminstat.users.group_ref_new.one of rules is empty')
                    });
                    return true;
                }
                if (me.sources[sourceIndex].id == 0) {
                    // Если этот источник еще не сохранен, то добавить его в базу
                    me.rulesBusy[sourceIndex] = me.groupRefService.saveSource(me.sources[sourceIndex]).subscribe(function (data) {
                        me.sources[sourceIndex].id = data[1].id;
                        me.sources[sourceIndex].isSourceEdit = false;
                    });
                }
                else {
                    // В противном случае просто обновить
                    me.rulesBusy[sourceIndex] = me.groupRefService.editSource(me.sources[sourceIndex]).subscribe(function (data) {
                        me.sources[sourceIndex].isSourceEdit = false;
                    });
                }
            }
        });
    };
    GroupRefComponent.prototype.openGroup = function (id) {
        var me = this;
        me.currentGroup = this.groups.find(function (group) { return group.id == id; });
        me.sources = [];
        me.sourcesBusy = me.groupRefService.getSources(me.currentGroup.id).subscribe(function (sources) {
            me.sources = sources;
        });
    };
    GroupRefComponent.prototype.deleteRule = function (ruleIndex, sourceIndex) {
        var rules = this.sources[sourceIndex].rules;
        if (rules.length == 1) {
            this.modalService.open(AlertComponent, {
                title: this._translate.instant('adminstat.users.group_ref_new.deleting rule'),
                message: this._translate.instant('adminstat.users.group_ref_new.can not delete last rule')
            });
        }
        else {
            var rule = rules[ruleIndex], exprId = rule.exprId, exprStart = rule.exprStart, exprEnd = rule.exprEnd, length = 0;
            rules.splice(ruleIndex, 1);
            // Проверки для OR правил
            if (exprId != 0 && (exprStart || exprEnd)) {
                // Узнать количество правил с таким же exprId
                for (var i = 0; i < rules.length; i++) {
                    if (exprId == rules[i].exprId)
                        length++;
                }
                // Если осталось только одно правило OR, то превратить его в AND
                if (length == 1) {
                    for (var i = 0; i < rules.length; i++) {
                        if (exprId == rules[i].exprId) {
                            rules[i].isExpr = false;
                            rules[i].exprStart = false;
                            rules[i].exprEnd = false;
                            rules[i].exprId = 0;
                        }
                    }
                }
                else {
                    // Если было удалено первое правило из подгруппы, то обновить exprStart
                    if (exprStart == true) {
                        for (var i = 0; i < rules.length; i++) {
                            if (exprId == rules[i].exprId) {
                                rules[i].exprStart = true;
                                rules[i].exprEnd = false;
                                break;
                            }
                        }
                    }
                    // Если было удалено последнее правило из подгруппы, то обновить exprEnd
                    if (exprEnd == true) {
                        for (var i = rules.length - 1; i >= 0; i--) {
                            if (exprId == rules[i].exprId) {
                                rules[i].exprStart = false;
                                rules[i].exprEnd = true;
                                break;
                            }
                        }
                    }
                }
            }
        }
    };
    GroupRefComponent.prototype.addRule = function (cond, ruleIndex, sourceIndex) {
        if (this.sources[sourceIndex].rules.length > 9) {
            this.modalService.open(AlertComponent, {
                title: this._translate.instant('adminstat.users.group_ref_new.adding rule'),
                message: this._translate.instant('adminstat.users.group_ref_new.max 10 rules')
            });
            return true;
        }
        var rules = this.sources[sourceIndex].rules;
        if (cond == 'and') {
            rules.splice(ruleIndex + 1, 0, {
                filter: '',
                state: '',
                text: '',
                isExpr: false,
                exprId: 0,
                exprStart: false,
                exprEnd: false
            });
        }
        else if (cond == 'or') {
            var rule = this.sources[sourceIndex].rules[ruleIndex], exprId = 0, exprStart = false, exprEnd = false;
            if (rule.exprId != 0) {
                // Добавить or к уже существующему
                exprId = rule.exprId;
                exprStart = false;
                exprEnd = true;
            }
            else {
                // Найти максимальный exprId
                var max_1 = 0;
                rules.forEach(function (rule) {
                    if (rule.exprId > max_1)
                        max_1 = rule.exprId;
                });
                exprId = max_1 + 1;
                exprStart = false;
                exprEnd = true;
            }
            if (rule.isExpr == false) {
                rule.isExpr = true;
                rule.exprId = exprId;
                rule.exprStart = true;
            }
            rule.exprEnd = false;
            rules.splice(ruleIndex + 1, 0, {
                filter: '',
                state: '',
                text: '',
                isExpr: true,
                exprId: exprId,
                exprStart: exprStart,
                exprEnd: exprEnd
            });
        }
    };
    GroupRefComponent.prototype.rebuild = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, r;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        return [4 /*yield*/, me.groupRefService.rebuild().toPromise()];
                    case 1:
                        r = _a.sent();
                        console.log('r', r);
                        return [2 /*return*/];
                }
            });
        });
    };
    return GroupRefComponent;
}());
export { GroupRefComponent };
